function init() {
  const shape = $(this).find('.text-shaped .shape');
  shape.css('height', shape.parent().height());
  setTimeout(() => {
    shape.css('height', shape.parent().height());
  }, 0);
}

export default function () {
  $('section[data-block=hero]').each(init);
}
